import { FAIZ_ACCESS_TOKEN, FAIZ_AUTH_EMAIL } from "./staticKeys";

export const getAccessToken = () => localStorage.getItem(FAIZ_ACCESS_TOKEN);

export const setAccessToken = (token) => localStorage.setItem(FAIZ_ACCESS_TOKEN, token);

export const getAuthenticatedEmail = () => localStorage.getItem(FAIZ_AUTH_EMAIL);

export const setAuthenticatedEmail = (email) =>
  localStorage.setItem(FAIZ_AUTH_EMAIL, String(email || "").trim().toLowerCase());

export const clearAccessToken = () => {
  localStorage.removeItem(FAIZ_ACCESS_TOKEN);
  localStorage.removeItem(FAIZ_AUTH_EMAIL);
};

export const hasAccessToken = () => {
  const token = getAccessToken();
  return token !== null && token !== "";
};
